const DEFAULT_API_BASE_PATH = '/api/admin';

const trimTrailingSlash = (value = '') => value.replace(/\/+$/, '');

export const getApiBaseUrl = () => {
  const configured = `${process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_PATH}`.trim();
  return trimTrailingSlash(configured) || DEFAULT_API_BASE_PATH;
};

export const getApiOrigin = () => {
  const baseUrl = getApiBaseUrl();
  try {
    if (baseUrl.startsWith('/')) {
      return typeof window !== 'undefined' ? window.location.origin : '';
    }
    return new URL(baseUrl).origin;
  } catch {
    return typeof window !== 'undefined' ? window.location.origin : '';
  }
};

export const buildApiUrl = (path = '') => {
  if (!path) return getApiBaseUrl();
  if (/^https?:\/\//i.test(path)) return path;

  const baseUrl = getApiBaseUrl();
  if (path.startsWith(DEFAULT_API_BASE_PATH)) {
    return `${baseUrl}${path.slice(DEFAULT_API_BASE_PATH.length)}`;
  }
  if (path.startsWith('/')) {
    return `${baseUrl}${path}`;
  }
  return `${baseUrl}/${path}`;
};

export const buildOriginUrl = (path = '') => {
  if (!path) return getApiOrigin();
  if (/^https?:\/\//i.test(path)) return path;

  const origin = getApiOrigin();
  return `${origin}${path.startsWith('/') ? path : `/${path}`}`;
};
